<script setup lang="ts">
import { computed } from 'vue';
import type { Emits, Props } from './switcher';
import ControlLabel from '../controlLabel/controlLabel.vue';

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const localValue = computed({
	get() {
		return props.modelValue;
	},
	set(value) {
		emit('update:modelValue', value);
	},
});
</script>

<template>
	<label
		:class="{
		['top-forms-optionWrapper']: true,
		['top-checkboxSwitcher']: true,
		['top-disabled']: disabled,
		['top-error']: isError && !disabled,
	}"
	>
		<input
			v-top-focus.onupdate="isError"
			type="checkbox"
			:class="{
				['top-forms-focusable']: !disabled,
				['top-forms-option']: true,
				['top-checkboxSwitcher_input']: true,
				['top-error']: isError && !disabled,
			}"
			v-model="localValue"
			:name="name"
			:value="value"
			:disabled="disabled"
		>

		<ControlLabel
			v-if="$slots.default"
			:description="description"
			:disabled="disabled"
		>
			<!-- @slot Слот с заголовком -->
			<slot></slot>
		</ControlLabel>
	</label>
</template>

<style>
.top-checkboxSwitcher {
	cursor: pointer;
	display: inline-flex;
	gap: 4px;
}

.top-checkboxSwitcher_input {
	border-radius: 9px;
	border: none;
	background: var(--color-layer-3);
	width: 36px;
	height: 18px;
	position: relative;
}

.top-checkboxSwitcher_input:before {
	content: "";
	border-radius: 50%;
	background: var(--color-white);
	width: 12px;
	height: 12px;
	margin: 3px;
	position: absolute;
	top: 0;
	left: 0;

	transition: left 0.1s;
}

.top-checkboxSwitcher_input:hover {
	background: var(--color-layer-4);
}

/* checked */
.top-checkboxSwitcher_input:checked {
	background: var(--top-forms-option-color);
}

.top-checkboxSwitcher_input:checked:hover {
	background: var(--top-forms-option-color-hover);
}

.top-checkboxSwitcher_input:checked:before {
	left: 50%;
}

/* isError */
.top-checkboxSwitcher_input.top-error {
	background: var(--color-layer-negative-3);
}

.top-checkboxSwitcher_input.top-error:hover {
	background: var(--color-layer-negative-4);
}

.top-checkboxSwitcher_input.top-error:checked {
	background: var(--color-bg-negative-2);
}

.top-checkboxSwitcher_input.top-error:checked:hover {
	background: var(--color-bg-negative-1);
}

</style>
